import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, Check, ArrowRight, Tv, Palette, Plus } from 'lucide-react';
import { Button } from '@/components/ui/Button';

const steps = [
  { icon: Sparkles, title: 'Bem-vindo!', desc: 'Vamos preparar sua conta em alguns passos.' },
  { icon: Tv, title: 'Conecte sua primeira TV', desc: 'Plug-and-play em menos de 2 minutos.' },
  { icon: Palette, title: 'Escolha um tema', desc: 'Visual pronto para o seu tipo de negócio.' },
  { icon: Plus, title: 'Pronto!', desc: 'Comece a criar conteúdo.' },
];

export function OnboardingPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const Icon = steps[step].icon;

  return (
    <div className="container-app py-12">
      <div className="max-w-2xl mx-auto">
        <div className="flex justify-center gap-2 mb-8">
          {steps.map((_, i) => (
            <div key={i} className={`h-2 w-12 rounded-full ${i <= step ? 'bg-brand-600' : 'bg-muted'}`} />
          ))}
        </div>

        <div className="text-center">
          <div className="grid place-items-center h-20 w-20 rounded-2xl gradient-brand mx-auto">
            <Icon className="h-10 w-10 text-white" />
          </div>
          <h1 className="mt-6 text-3xl font-bold">{steps[step].title}</h1>
          <p className="mt-2 text-muted-foreground">{steps[step].desc}</p>

          <div className="mt-10 flex justify-center gap-3">
            {step > 0 && <Button variant="outline" onClick={() => setStep(step - 1)}>Voltar</Button>}
            {step < steps.length - 1 ? (
              <Button onClick={() => setStep(step + 1)} variant="gradient">
                Próximo <ArrowRight className="h-4 w-4" />
              </Button>
            ) : (
              <Button onClick={() => navigate('/dashboard')} variant="gradient">
                Ir pro dashboard <Check className="h-4 w-4" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
